module.exports = __webpack_public_path__ + "img/pr-12.70d04336.png";